import RenderProps from 'assets/components/helpers/RenderProps';
import { useTheme } from 'assets/hooks/theme/useTheme';
import { first } from 'lodash';
import useFileInput from './hooks/FileInput';

export enum FileInputStructure {
  formInput = 'formInput',
  input = 'input',
}
export type Verify = Utils.VerifyExtends<Component.Input.File.Structure, typeof FileInputStructure>;
export default function FileInputSimple(
  props: Omit<Component.Input.File.Import, 'fileLimit' | 'value' | 'onChange'> & {
    value?: Hooks.Input.File.Info;
    onChange(files: { [name: string]: Hooks.Input.File.Info | undefined });
  }
) {
  const extend = useTheme(FileInputStructure, props);
  const { fileInput, isActive, handleFileSelect, limit } = useFileInput({
    ...props,
    fileLimit: 1,
    value: props.value ? [props.value] : [],
    onChange: ({ [props.name]: namedValue }) => props.onChange({ [props.name]: first(namedValue) }),
  });

  return (
    <div
      {...extend(FileInputStructure.formInput, true)}
      data-label={props.label}
      data-error={props.error || undefined}
      data-active={isActive ? true : undefined}
    >
      {RenderProps(props, 'renderBefore', { limit })}
      <input
        {...extend(FileInputStructure.input)}
        onClick={(event) => event.stopPropagation()}
        onChange={handleFileSelect}
        type="file"
        ref={fileInput}
        name={props.name as string}
        accept={props.allowedMimeTypes ? props.allowedMimeTypes.join(', ') : '*'}
        multiple={false}
        disabled={props.disabled}
      />
      {RenderProps(props, 'renderAfter', { limit })}
    </div>
  );
}
